var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconObKb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M112.785,54.671h-5c-.724,8.7,1.041,12.475-11.384,26.345-16.018,17.879-9.378,31.207-3.624,38.4h20.006a3.38,3.38,0,0,0,3.171-3.539V58.21A3.38,3.38,0,0,0,112.785,54.671Z",
    transform: "translate(-86.387 -54.671)",
    fill: "#f2f8ff",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-ob-kb",
    transform: "translate(-308 -969)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(308 969)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3834",
    "data-name": "Group 3834",
    transform: "translate(328 985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3831",
    "data-name": "Group 3831"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1189",
    "data-name": "Rectangle 1189",
    width: 58.05,
    height: 66.35,
    rx: 6.9,
    transform: "translate(1 1)",
    fill: "#88c4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3832",
    "data-name": "Group 3832"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1189-2",
    "data-name": "Rectangle 1189",
    width: 56.444,
    height: 64.745,
    rx: 4,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_351",
    "data-name": "Mask Group 351",
    transform: "translate(26.875)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1189-3",
    "data-name": "Rectangle 1189",
    width: 56.444,
    height: 64.745,
    rx: 4,
    transform: "translate(-26.875 0)",
    fill: "#f2f8ff"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1508",
    "data-name": "Rectangle 1508",
    width: 49,
    height: 2,
    rx: 1,
    transform: "translate(3.896 56.705)",
    fill: "#18ce99"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1509",
    "data-name": "Rectangle 1509",
    width: 28,
    height: 2,
    rx: 1,
    transform: "translate(24.896 51.705)",
    fill: "#2092ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1510",
    "data-name": "Rectangle 1510",
    width: 7,
    height: 2,
    rx: 1,
    transform: "translate(3.896 46.705)",
    fill: "#2092ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1511",
    "data-name": "Rectangle 1511",
    width: 21,
    height: 2,
    rx: 1,
    transform: "translate(3.896 41.705)",
    fill: "#2092ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1512",
    "data-name": "Rectangle 1512",
    width: 9,
    height: 2,
    rx: 1,
    transform: "translate(3.896 36.705)",
    fill: "#18ce99"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1513",
    "data-name": "Rectangle 1513",
    width: 32,
    height: 2,
    rx: 1,
    transform: "translate(3.896 31.705)",
    fill: "#2092ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1514",
    "data-name": "Rectangle 1514",
    width: 26,
    height: 2,
    rx: 1,
    transform: "translate(3.896 26.705)",
    fill: "#2092ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1515",
    "data-name": "Rectangle 1515",
    width: 49,
    height: 2,
    rx: 1,
    transform: "translate(3.896 21.705)",
    fill: "#2092ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1517",
    "data-name": "Rectangle 1517",
    width: 22,
    height: 2,
    rx: 1,
    transform: "translate(3.896 11.705)",
    fill: "#f4d93b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1518",
    "data-name": "Rectangle 1518",
    width: 49,
    height: 2,
    rx: 1,
    transform: "translate(3.896 6.705)",
    fill: "#f4d93b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1523",
    "data-name": "Rectangle 1523",
    width: 13,
    height: 2,
    rx: 1,
    transform: "translate(31.896 26.705)",
    fill: "#2092ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1524",
    "data-name": "Rectangle 1524",
    width: 6,
    height: 2,
    rx: 1,
    transform: "translate(46.896 26.705)",
    fill: "#18ce99"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1525",
    "data-name": "Rectangle 1525",
    width: 15,
    height: 2,
    rx: 1,
    transform: "translate(37.896 31.705)",
    fill: "#2092ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1526",
    "data-name": "Rectangle 1526",
    width: 38,
    height: 2,
    rx: 1,
    transform: "translate(14.896 36.705)",
    fill: "#2092ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1527",
    "data-name": "Rectangle 1527",
    width: 26,
    height: 2,
    rx: 1,
    transform: "translate(26.896 41.705)",
    fill: "#2092ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1528",
    "data-name": "Rectangle 1528",
    width: 28,
    height: 2,
    rx: 1,
    transform: "translate(12.896 46.705)",
    fill: "#2092ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1529",
    "data-name": "Rectangle 1529",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(42.896 46.705)",
    fill: "#18ce99"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1530",
    "data-name": "Rectangle 1530",
    width: 19,
    height: 2,
    rx: 1,
    transform: "translate(3.896 51.705)",
    fill: "#2092ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconObKb);
export default __webpack_public_path__ + "static/media/icon-ob-kb.1b27cb242db3b66825662b92cc4dd77b.svg";
export { ForwardRef as ReactComponent };